'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CALYPSO } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import UIIcon from 'UIComponents/icon/UIIcon';
import { crmSuiteProductLevelSelector, skuIdIsAddonOrServiceSelector } from '../../selectors/ProductsSelectors';
import ExpandableChecklistItem from './ExpandableChecklistItem';
const TextContainer = styled.div.withConfig({
  displayName: "ExpandableChecklist__TextContainer",
  componentId: "sc-7cwmj3-0"
})(["margin-top:40px;padding-bottom:20px;&:hover{cursor:pointer;}"]);
const StyledTitleContainer = styled.span.withConfig({
  displayName: "ExpandableChecklist__StyledTitleContainer",
  componentId: "sc-7cwmj3-1"
})(["margin-bottom:8px;"]);

const ExpandableChecklist = ({
  title,
  subtext,
  skuIds = [],
  selectedProductConfigurations,
  onSelectedChange,
  use,
  defaultOpen,
  trackAccordionInteraction,
  queryParamTerm
}) => {
  const hasSelectedMerch = useSelector(state => selectedProductConfigurations.filter(({
    skuId
  }) => skuIdIsAddonOrServiceSelector(state, {
    skuId
  })).length > 0);
  const [isOpen, setIsOpen] = useState(defaultOpen || hasSelectedMerch);
  const iconName = isOpen ? 'minus' : 'add';

  const toggleAccordion = () => {
    const newAccordionState = !isOpen;
    setIsOpen(newAccordionState);
    trackAccordionInteraction(use, newAccordionState);
  };

  const isSuite = useSelector(state => {
    const selectedSkuIds = selectedProductConfigurations.map(({
      skuId
    }) => skuId);
    return Boolean(crmSuiteProductLevelSelector(state, {
      skuIds: selectedSkuIds
    }));
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(TextContainer, {
      onClick: toggleAccordion,
      "data-selenium-id": `plan-builder-${use}-checklist-toggle`,
      children: [/*#__PURE__*/_jsx(StyledTitleContainer, {
        children: title
      }), /*#__PURE__*/_jsxs(UIFlex, {
        direction: "row",
        justify: "between",
        children: [subtext, /*#__PURE__*/_jsx(UIIcon, {
          color: CALYPSO,
          name: iconName,
          size: "small"
        })]
      })]
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      open: isOpen,
      className: "m-bottom-12",
      "data-selenium-id": `plan-builder-${use}-checklist`,
      children: skuIds.map(skuId => {
        const selectedProductConfiguration = selectedProductConfigurations.find(({
          skuId: searchSkuId
        }) => searchSkuId === skuId);
        return /*#__PURE__*/_jsx(ExpandableChecklistItem, {
          skuId: skuId,
          selectedQuantity: selectedProductConfiguration && selectedProductConfiguration.quantity || 0,
          onSelectedChange: onSelectedChange,
          isSuite: isSuite,
          use: use,
          queryParamTerm: queryParamTerm
        }, skuId);
      })
    })]
  });
};

export default ExpandableChecklist;